import { useCallback, useEffect, useRef } from 'react';

export const useInfiniteScroll = (
  fetchData: () => void,
  isLoading: boolean,
  hasMore: boolean,
  threshold = 0.7,
) => {
  const containerRef = useRef<HTMLDivElement>(null);

  const checkScroll = useCallback(() => {
    if (isLoading || !hasMore || !containerRef.current) return;

    const { scrollTop, scrollHeight, clientHeight } = containerRef.current;
    if (scrollTop + clientHeight >= scrollHeight * threshold) {
      fetchData();
    }
  }, [fetchData, hasMore, isLoading, threshold]);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    container.addEventListener('scroll', checkScroll);
    return () => container.removeEventListener('scroll', checkScroll);
  }, [checkScroll]);

  return {
    containerRef,
    scrollProps: {
      style: {
        height: '70vh',
      },
    },
  };
};
